import filterIcon from "./filter.svg";
import styles from '../header/Header.module.scss';

interface IProps {
  isMobile?: boolean
}

const Filters = ({ isMobile }: IProps) => !isMobile ? (
  <img className={styles.filterIconPath} src={filterIcon} alt="" aria-hidden="true" width={24} height={24} />
) : (
  <img src={filterIcon} alt="" aria-hidden="true" width={24} height={24} />
)
export default Filters
